import { FC } from 'react';
import { helpGroups } from 'pro/config/help';
import { Link } from '@base/lib/Link';
import { LoopRender } from '@base/snippets/LoopRender';
import { Dropdown } from 'antd';
import { generatePath } from 'ava-util/dist/request';
import { RouteEnum } from 'pro/config/routers';
import { Products } from './Products';
import cn from 'classnames';
import styles from './index.module.less';

const transLink = (link: string) => {
    return link === RouteEnum.CONTACT ? generatePath(RouteEnum.CONTACT, { from: 'Header Navigation' }) : link;
}

export const HeaderNav: FC = () => {
    return (
        <div className={cn(styles['header-nav'], 'flex flex-middle flex-1')}>
            <Products/>

            <LoopRender
                tag={false}
                list={helpGroups}
                render={group => {
                    return !group.list?.length ? (
                        <Link href={transLink(group.link)} className={styles['nav-link1']}>{group.title}</Link>
                    ) : (
                        <Dropdown
                            menu={{
                                items: group.list.map(item => ({
                                    key: item.title,
                                    label: (
                                        <Link href={transLink(item.link)} className={styles['nav-link2']}>{item.title}</Link>
                                    )
                                }))
                            }}
                            placement="bottom"
                            overlayClassName={styles.menu}
                            align={{ offset: [0, 0] }}
                        >
                            <Link
                                href={transLink(group.link)}
                                className={styles['nav-link1']}
                            >
                                {group.title}
                            </Link>
                        </Dropdown>
                    )
                }}
            />
        </div>
    );
}